import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchCostSummaryViewerData = createAsyncThunk(
	"costSummary/fetchCostSummaryViewerData",
	async ({ costSummaryId }, { rejectWithValue, extra }) => {
		try {
			const { data } = await extra.apiCostSummary.getViewerData({ costSummaryId });
			return data;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);
